import React from 'react';

const MOBILE_MAX = 600;
const DESKTOP_MIN = 1024;
const TABLET_MIN = MOBILE_MAX + 1;
const TABLET_MAX = DESKTOP_MIN - 1;

export default function isResizable(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isMobile: window.innerWidth <= MOBILE_MAX,
        isTablet:
          window.innerWidth >= TABLET_MIN &&
          window.innerWidth <= TABLET_MAX,
        isDesktop: window.innerWidth >= DESKTOP_MIN,
      };
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setState({
          isMobile: window.innerWidth <= MOBILE_MAX,
          isTablet:
            window.innerWidth >= TABLET_MIN &&
            window.innerWidth <= TABLET_MAX,
          isDesktop: window.innerWidth >= DESKTOP_MIN,
        });
      }, 50);
    };

    render() {
      const { isMobile, isTablet, isDesktop } = this.state;

      return (
        <WrappedComponent
          {...this.props}
          {...{ isMobile, isTablet, isDesktop }}
        />
      );
    }
  };
}